import React, { Fragment } from "react";
import {
    ModalBlock,
    ModalBody,
    ModalContainer,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalTitle,
} from "./styles";

export interface IModal {
    title: string;
    footer?: React.ReactNode;
    children?: React.ReactNode;
    active: boolean;
    hideModal: Function;
}

const Modal: React.FC<IModal> = ({
    title,
    footer,
    children,
    active,
    hideModal,
}) => {
    return (
        <Fragment>
            {active && (
                <ModalBlock>
                    <ModalOverlay onClick={() => hideModal()}></ModalOverlay>
                    <ModalContainer>
                        <ModalHeader>
                            <ModalTitle>{title}</ModalTitle>
                            {/* <ModalClose onClick={() => hideModal()}>
                                X
                            </ModalClose> */}
                        </ModalHeader>
                        {children && <ModalBody>{children}</ModalBody>}
                        {footer && <ModalFooter>{footer}</ModalFooter>}
                    </ModalContainer>
                </ModalBlock>
            )}
        </Fragment>
    );
};
export default Modal;
